<template>
  <!--文章详情-->
  <tk-container
    :status="status"
    class="b-g-f"
    @refresh="refreshInit"
  >
    <!--文章头部-->
    <my-header slot="header"></my-header>
    <!--文章详情-->
    <div
      class="article-detail p-12"
      v-if="articleDetail"
    >
      <!--标题-->
      <div class="font-bold copy-text">
        {{articleDetail.articleTitle}}
      </div>
      <!--内容-->
      <div
        class="font-14 m-t-10 article-detail-color copy-text"
        id="article-html"
        @click="viewImages($event, articleDetail.IntroductionEvent)"
        v-html="articleDetail.IntroductionEvent"></div>
      <!--底部信息-->
      <tk-flex bottom between class="m-t-16 caption">
        <div>{{articleDetail.createdAt | datetime}}</div>
        <tk-flex>
          <div>{{articleDetail.readingSum | transform}}阅读</div>
          <div class="m-l-15">{{(articleDetail.reviewsPostsList ? articleDetail.reviewsPostsList.length : 0) | transform}}评论</div>
        </tk-flex>
      </tk-flex>
      <!--评论-->
      <div class="posts-card-footer-bottom" v-if="articleDetail.reviewsPostsList && articleDetail.reviewsPostsList.length">
        <div
          v-for="(item, firstIndex) in articleDetail.reviewsPostsList"
          :key="`posts-card-footer-bottom${firstIndex}`"
          class="p-t-2"
        >
          <tk-flex column class="fill font-12">
            <tk-flex column middle class="full-width">
              <div
                class="posts-card-footer-bottom-color full-width"
                v-if="item.reviewer"
                :class="{ 'posts-card-footer-bottom-active': isShowTouch &&
                       deleteRender.index === firstIndex && Object.keys(deleteRender.data).length,
                       'posts-card-footer-bottom-radius': firstIndex === (articleDetail.reviewsPostsList.length - 1) }"
                @touchstart="gtouchstart($event, item.reviewer, item, firstIndex)"
                @touchmove="gtouchmove()"
                @touchend="gtouchend(item.reviewer, item, firstIndex)"
              >
                <span class="font-bold">{{(item.reviewer.name ? item.reviewer.name : '用户') + '：'}}</span>
                <span style="color: #000000;">{{item.reviewerContent ? item.reviewerContent : '无评论信息'}}</span>
              </div>
              <!--回复数据-->
              <div
                v-if="item.whatToReply && item.whatToReply.length"
                class="full-width"
              >
                <tk-flex
                  middle
                  between
                  class="full-width"
                  v-for="(m, index) in item.whatToReply"
                  :key="`whatToReply${index}`"
                >
                  <div
                    class="posts-card-footer-bottom-color font-bold"
                  >
                    <span @click="enterReplytoe(m.replytoe, item, articleDetail, firstIndex)">{{m.replytoe.name}}</span>
                    <span class="m-x-5" style="font-weight: normal;color: #000000;">回复</span>
                    <span  @click.stop="enterReplytoe(m.recipient, item, articleDetail, firstIndex)">{{m.recipient.name + '：'}}</span>
                    <span style="font-weight: normal;color: #000000;">{{m.content}}</span>
                  </div>
                  <div
                    v-if="m.replytoe.objectId === userInfo.objectId"
                    class="delete-replytoe"
                    :style="{ background: isDelReplytoe ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0)' }"
                    @click="deleteReplyToe(m.replytoe, firstIndex, index)"
                  >
                    <tk-icon :size="14" :color="isDelReplytoe ? '#eaeaea' : '#999'">lajixiang</tk-icon>
                  </div>
                </tk-flex>
              </div>
            </tk-flex>
          </tk-flex>
        </div>
      </div>
    </div>
    <!--输入框-->
    <div
      slot="footer"
      class="comments"
    >
      <tk-flex bottom class="fill">
        <div class="comments-bg">
          <tk-flex middle>
            <textarea-autosize
              ref="textarea"
              :placeholder="placeholder"
              @focus.native.prevent="getOnBlur()"
              style="padding-left: 8px;"
              class="comments-area fill p-y-5 p-r-4"
              name="opinion"
              id="postsTextarea"
              cols="40" rows="1"
              v-model="comments"
              :min-height="32"
              :max-height="350"
            ></textarea-autosize>
          </tk-flex>
        </div>
        <div class="comments-btn text-right m-l-5" v-show="isBtnShow">
          <tkui-button @click="enterComments" :disabled="!comments" class="comments-btn-enter primary small raised">发送</tkui-button>
        </div>
        <tk-flex
          @click.native.stop="likesArticle"
          center
          top
          class="p-t-4"
          style="position:relative;width: 22%;"
        >
          <tk-icon v-if="!judgeUserFans(userInfo.objectId)" size="32" color="#999" class="m-l-10 flex-shrink-0">dianzan</tk-icon>
          <tk-icon v-else size="32" color="#FA3333" class="m-l-10 flex-shrink-0">yidianzan</tk-icon>
          <div class="comments-favorite caption">{{(articleDetail && articleDetail.userFans ? articleDetail.userFans.length : 0) | transform}}</div>
        </tk-flex>
      </tk-flex>
    </div>
    <!--删除评论弹框-->
    <tk-cover
      :show.sync="isShowTouch"
      :color="'rgba(255, 255, 255, 0)'"
      transition
    >
      <tk-flex
        middle
        column
        class="posts-detail-delete"
        :style="{ left: clientLeft - 32 + 'px', top: clientTop - 118 + 'px' }"
      >
        <div class="font-14 text-gray" @click="copyReviews()">复制</div>
        <div style="margin-top: 35px;" class="text-gray font-14" @click="deleteSelfReplytoe()">删除</div>
      </tk-flex>
    </tk-cover>
    <!--查看大图组件-->
    <view-big-image
      ref="articleDetail"
      :watch-num="watchNum"
      v-if="articleDetail && getArticleImage(articleDetail.IntroductionEvent)"
      :commodity-image="getArticleImage(articleDetail.IntroductionEvent)"
    ></view-big-image>
  </tk-container>
</template>

<script>
import viewBigImage from '@/components/viewBigImage'
const copy = require('clipboard-copy')
export default {
  components: {
    viewBigImage
  },
  data () {
    return {
      status: 'loading', // 页面状态
      enterLoading: false,
      deleteRender: {
        recipient: {},
        data: {},
        index: 0
      },
      watchNum: 0, // 查看大图的起始缩影
      isShowTouch: false, // 长按后的的弹框
      isDelReplytoe: false, // 删除回复状态
      timeOutEvent: 0, // 长按延时器定义
      clientTop: 0, // 弹框位置
      clientLeft: 0, // 弹框位置
      height: '30px', // textarea默认高度
      imageInstance: null, // 图片预览实例
      articleDetail: null, // 指定文章详情数据
      praiseDisable: false, // 点赞状态
      watchDisabled: false, // 关注状态
      isBtnShow: false, // 按钮显示状态
      placeholder: '发表评论...', // 输入框提示
      recipient: null, // 接收人信息
      reviewsIndex: 0, // 回复人的索引
      reviewsData: null, // 回复人信息
      comments: '' // 评论内容
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el) {
        el.focus()
      }
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.$setFlash('updateArticle', this.articleDetail)
    if (this.imageInstance) { this.imageInstance.close() }
    this.clearSelector()
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/3/26
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getArticleDetail() // 获取文章详情
        await this.addReadingSum() // 增加阅读量
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 清除选中
    * @date: 2020/8/28
    */
    clearSelector () {
      if (window.getSelection()) {
        const selection = window.getSelection()
        selection.removeAllRanges()
      } else if (document.selection && document.selection.empty) {
        document.selection.empty()
        // document.selection.clear()
      }
    },
    /**
     * 数据错误重新加载触发
     * @date: 2020/3/26
     */
    async refreshInit () {
      await this.getInit()
    },
    /**
     * 获取指定文章详情
     * @date: 2020/3/26
     */
    async getArticleDetail () {
      this.articleDetail = await this.$tkParse.getData(`/classes/${this.$route.query.type}/${this.$route.query.id}`)
      if (!this.articleDetail.readingSum) { this.articleDetail.readingSum = 0 }
      if (!this.articleDetail.reviewsPostsList) { this.articleDetail.reviewsPostsList = [] }
      if (!this.articleDetail.userFans) { this.articleDetail.userFans = [] }
    },
    /**
    * 增加阅读量
    * @date: 2020/4/14
    */
    async addReadingSum () {
      await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.$route.query.id}`, { readingSum: this.articleDetail.readingSum + 1 })
      await this.getArticleDetail() // 获取文章详情
    },
    /**
     * 获取html中的图片
     * @date: 2020/3/23
     */
    getArticleImage (str) {
      let list = []
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (
          match,
          capture
        ) {
          list.push(capture)
        })
      if (!list.length) { return [''] }
      return list
    },
    /**
     * 查看大图
     * @date: 2020/5/25
     */
    viewImages (e, html) {
      let listImage = this.getArticleImage(html)
      if (e.target.nodeName === 'IMG') {
        this.watchNum = listImage.findIndex(s => { return s === e.target.src })
        this.$refs.articleDetail.showImages()
      } else {
        this.watchNum = 0
      }
    },
    /**
     * 判断点赞数组
     * @date: 2020/4/11
     */
    judgeUserFans (id) {
      if (!this.articleDetail) { return false }
      if (!this.articleDetail.userFans) { this.articleDetail.userFans = [] }
      let index = this.articleDetail.userFans.findIndex(s => { return s.objectId === id })
      return index !== -1
    },
    /**
     * 点赞文章
     * @date: 2020/4/11
     */
    async likesArticle () {
      if (!await this.judgeId(this.articleDetail.objectId, this.$route.query.type)) {
        return this.$tkGlobal.toast.add('此文章可能已删除')
      }
      if (this.praiseDisable) { return this.$tkGlobal.toast.add('您点的太快了') }
      this.praiseDisable = true
      // 数据
      if (!this.judgeUserFans(this.userInfo.objectId)) { // 点赞
        if (!this.articleDetail.userFans) { this.articleDetail.userFans = [] }
        this.articleDetail.userFans.push({
          objectId: this.userInfo.objectId,
          name: this.userInfo.name ? this.userInfo.name : '用户',
          phone: this.userInfo.phone,
          avatar: this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
        })
        await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`, { userFans: this.articleDetail.userFans })
        this.$tkGlobal.toast.add('点赞成功')
        setTimeout(() => { this.praiseDisable = false }, 500)
        this.$forceUpdate()
        return
      }
      // 取消赞
      let findIndex = this.articleDetail.userFans.findIndex(s => { return s.objectId === this.userInfo.objectId })
      this.articleDetail.userFans.splice(findIndex, 1)
      await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`, { userFans: this.articleDetail.userFans })
      this.$tkGlobal.toast.add('取消成功')
      setTimeout(() => { this.praiseDisable = false }, 500)
      this.$forceUpdate()
    },
    /**
    * 获取焦点
    * @date: 2020/4/11
    */
    getOnBlur () {
      this.isBtnShow = true
    },
    /**
     * 长按操作
     * @date: 2020/8/21
     */
    gtouchstart (e, recipient, data, index) {
      this.timeOutEvent = setTimeout(() => {
        this.longPress(e, recipient, data, index)
      }, 100)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend (recipient, data, index) {
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        // alert('你这是点击，不是长按')
        // recipient 接收人 replytoe 回复人
        if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
        if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
        this.reviewsData = data // 获取评论的信息
        this.recipient = recipient // 获取接收人信息
        this.reviewsIndex = index
        this.placeholder = `回复${recipient.name}：` // 改变placeholder
        this.$forceUpdate()
      }
      return false
    },
    /**
     * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
     * @date: 2020/8/21
     */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
     * 真正长按后应该执行的内容
     * @date: 2020/8/21
     */
    longPress (e, recipient, data, index) {
      if (recipient.objectId !== this.userInfo.objectId) {
        return
      }
      this.deleteRender = {
        recipient: {},
        data: {},
        index: 0
      }
      this.timeOutEvent = 0
      // 执行长按要执行的内容，如弹出菜单
      this.deleteRender = {
        recipient: recipient,
        data: data,
        index: index
      }
      this.clientTop = e.changedTouches['0'].clientY
      this.clientLeft = e.changedTouches['0'].clientX
      this.isShowTouch = true
    },
    /**
     * 删除自己跟帖评论或回复评论人
     * @date: 2020/8/20
     */
    async deleteSelfReplytoe () {
      let recipient = this.deleteRender.recipient
      let index = this.deleteRender.index
      this.isShowTouch = false
      if (recipient.objectId !== this.userInfo.objectId) { return }
      await this.subDelEnter(index)
    },
    /**
     * 删除跟帖评论
     * @date: 2020/8/20
     */
    async subDelEnter (index) {
      if (this.enterLoading) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (!this.articleDetail.reviewsPostsList[index]) {
        return this.$tkGlobal.toast.add('未找到该评论信息')
      }
      this.enterLoading = true
      this.articleDetail.reviewsPostsList.splice(index, 1)
      await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`, {
        reviewsPostsList: this.articleDetail.reviewsPostsList
      }).catch(e => {
        this.enterLoading = false
        throw this.$tkGlobal.toast.add('删除评论失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('评论删除成功')
      await this.$tkHelper.sleep(500)
      this.enterLoading = false
      this.$forceUpdate()
    },
    /**
     * 复制评论
     * @date: 2020/8/21
     */
    copyReviews () {
      copy(this.deleteRender.data.reviewerContent).then(s => {
        this.isShowTouch = false
        this.$tkGlobal.toast.add('复制评论成功')
      }).catch(e => {
        this.$tkGlobal.toast.add('复制评论失败')
      })
    },
    /**
     * 删除回复信息
     * @date: 2020/9/15
     */
    async deleteReplyToe (replytoe, index, idIndex) {
      if (this.isDelReplytoe) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (replytoe.objectId !== this.userInfo.objectId) {
        return this.$tkGlobal.toast.add('您没有该权限')
      }
      this.isDelReplytoe = true
      await this.$tkHelper.sleep(300)
      this.articleDetail.reviewsPostsList[index].whatToReply.splice(idIndex, 1)
      await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`, {
        reviewsPostsList: this.articleDetail.reviewsPostsList
      }).catch(e => {
        this.isDelReplytoe = false
        throw this.$tkGlobal.toast.add('删除回复信息失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('回复信息删除成功')
      await this.$tkHelper.sleep(500)
      this.isDelReplytoe = false
      this.$forceUpdate()
    },
    /**
     * 回复他人评论
     * @date: 2020/3/26
     */
    enterReplytoe (recipient, data, s, index) {
      // recipient 接收人 replytoe 回复人
      if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
      if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
      this.reviewsData = data // 获取评论的信息
      this.recipient = recipient // 获取接收人信息
      this.reviewsIndex = index
      this.placeholder = `回复${recipient.name}：` // 改变placeholder
      this.$forceUpdate()
    },
    // 给文章发送评论或回复其他人的评论
    async enterComments () {
      // 判断是否为评论
      if (!this.articleDetail) { return this.$tkGlobal.toast.add('未找到您要评论的文章') }
      let isPosts = await this.judgeId(this.articleDetail.objectId, this.$route.query.type)
      if (!isPosts) {
        this.$tkGlobal.toast.add('该文章已被删除')
        return
      }
      if (!this.comments) { return this.$tkGlobal.toast.add('评论内容不能为空') }
      // 获取最新的文章评论信息
      this.articleDetail = await this.$tkParse.getData(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`)
      // 获取服务器时间 即现在时间
      let nowTime = await this.$tkParse.getData(`https://api.mokekeji.com/time`)
      if (this.recipient && this.reviewsData) { // 回复信息
        this.reviewsData = this.articleDetail.reviewsPostsList[this.reviewsIndex]
        if (!this.reviewsData.whatToReply) { this.reviewsData.whatToReply = [] }
        let obj = {
          date: nowTime,
          content: this.comments,
          replytoe: this.userInfo,
          recipient: this.recipient
        }
        this.reviewsData.whatToReply.push(obj)
        // 更新页面数据显示
        this.articleDetail.reviewsPostsList[this.reviewsIndex] = this.reviewsData
        // 修改评论信息
        await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`,
          {
            reviewsPostsList: this.articleDetail.reviewsPostsList
          }
        )
        this.$tkGlobal.toast.add('回复成功')
      } else { // 评论信息
        if (!this.articleDetail.reviewsPostsList) { this.articleDetail.reviewsPostsList = [] }
        this.articleDetail.reviewsPostsList.push({
          date: nowTime,
          reviewer: this.userInfo,
          reviewerContent: this.comments
        })
        await this.$tkParse.put(`/classes/${this.$route.query.type}/${this.articleDetail.objectId}`,
          {
            reviewsPostsList: this.articleDetail.reviewsPostsList
          }
        )
        this.$tkGlobal.toast.add('评论成功')
      }
      this.comments = ''
      this.recipient = null
      this.reviewsData = null
      this.placeholder = '评论'
      this.isBtnShow = false
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
  .article-detail {
    display: table-cell;
    text-align: justify;
  }
  /*内容颜色*/
  .article-detail-color {
    color: rgba(66, 66, 66, 1);
    padding: 0 !important;
  }
   /*点赞及评论样式*/
  .posts-card-footer-bottom {
    padding-top: 10px;
    .posts-card-footer-bottom-tips {
      color: rgba(91, 108, 143, 1);
    }
    .posts-card-footer-bottom-color {
      font-size: 15px;
      color: rgba(91, 108, 143, 1);
      word-break: break-all;white-space: normal;
      .posts-card-footer-bottom-color-btn {
        min-width: 55px;
        height: 18px;
        border: 1px solid rgba(245, 245, 245, 1);
        border-radius: 9px;
        text-align: center;
        line-height: 18px;
      }
    }
    .delete-replytoe {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 19px;
      border-radius: 50%;
    }
    .posts-card-footer-bottom-color {
      font-size: 15px;
      color: rgba(91, 108, 143, 1);
      word-break: break-all;white-space: normal;
    }
    .posts-card-footer-bottom-active {
      background: #bababa !important;
    }
    .posts-card-footer-bottom-radius {
      border-radius: 0 0 5px 5px;
    }
  }
  /*v-html图片样式*/
  .article-detail-color {
    ::v-deep img {
      width: 100%;
      /*height: calc(100vw - 30px);*/
      /*border-radius: 5px;*/
      object-fit: cover;
      overflow: hidden;
    }
  }
  ::v-deep #article-html p {
    -webkit-user-select: text !important;
    user-select: text !important;
  }
  ::v-deep #article-html p span {
    -webkit-user-select: text !important;
    user-select: text !important;
  }
  /*删除评论弹框样式*/
  .posts-detail-delete {
    position: absolute;
    background: #fff;
    width: 75px;
    height: 110px;
    color: #000;
    padding-left: 15px;
    border-radius: 2px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  /*输入框样式*/
  .comments {
    border-top: 1px solid #f5f5f5;
    background-color: #f8f6f8;
    min-height: 47px;
    padding: 7px 12px 7px 12px;
    .comments-bg {
      width: 78%;
      height: 100%;
      position: relative;
      border-radius: 5px;
      background-color: #ffffff;
    }
    .comments-btn {
      .comments-btn-enter {
        border-radius: 5px;
        border: 1px solid #dad8d8;
        margin: 0;
        height: 32px;
      }
    }
    .comments-area {
      height: 100%;
      width: 100%;
      min-width: 0;
      overflow-y: auto;
      resize: none;
    }
    .comments-area::placeholder {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
    .comments-favorite {
      font-size: 10px !important;
    }
    ::v-deep .tkui-button.disabled {
      background: #f8f6f8 !important;
      opacity: 1 !important;
      color: #d6d3d6 !important;
    }
  }
</style>
